// removed by extract-text-webpack-plugin
module.exports = {"Container":"TakenVacc__Container___gtm9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HomeControl/TakenVacc/TakenVacc.css
// module id = 85
// module chunks = 0